import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './index.css';
import { ThemeProvider, CssBaseline, useTheme, useMediaQuery } from '@mui/material';
import theme from './components/LayoutComponents/theme';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import RegistrationPage from './pages/RegistrationPage';
import LoginPage from './pages/LoginPage';
import Compliance from './pages/Compliance/compliance';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPassword from './pages/ResetPassword';

function App() {
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY}
          scriptProps={{ async: true, defer: true, appendTo: "head" }}
        >
          <Router>
            <Routes>
              <Route path="/" element={<LoginPage isMobile={isMobile} />} />
              <Route path="/resetPassword" element={<ResetPassword isMobile={isMobile}/>} />
              <Route path="/forgotPassword" element={<ForgotPasswordPage isMobile={isMobile} />} />
              <Route path="/compliance" element={<Compliance />} />
              <Route path="/registration" element={<RegistrationPage isMobile={isMobile}/>} />
            </Routes>
          </Router>
        </GoogleReCaptchaProvider>
      </div>
    </ThemeProvider>
  );
}

export default App;